import React, { Component } from "react";
import { BASE_URL } from "./utility";

class Header extends Component {
  render() {
    return (
      <>
        <style>{`
          .header-container {
            vertical-align: middle;
          }

          .header-container img {
            display: block;
          }

          @media (min-width: 1200px) {
            .header-container {
              width: 160px;
              margin: 10px 6px 18px 12px;
            }

            .header-container img {
              width: 160px;
              max-width: 160px;
            }
          }

          @media (max-width: 1199px) {
            .header-container {
              display: flex !important;
              justify-content: center;
              align-items: center;
              margin: 0;
            }
          }
        `}</style>

        <div className="header-container" style={{ display: "inline-block" }}>
          <img
            height={90}
            width={200}
            src={BASE_URL + "download/general/name"}
            alt="Name"
            style={{ maxWidth: "90%", height: "auto" }}
          />
        </div>
      </>
    );
  }
}

export default Header;
